import { Fragment } from "react";
import TruckIcon from "../../../icons/truckIcon";
import TruckCard from "./truckCard";
import { useTranslation } from "react-i18next";
const trucks = [
  {
    img: "/assets/flatBed.png",
    name: "flatbed",
    length: "13.6 m",
    width: "2.4 m",
    height: "-",
  },
  {
    img: "/assets/reefer.jpg",
    name: "Reefer Truck",
    length: "13.20 – 13.5 m",
    width: "2.5 m",
    height: "2.6 m",
  },
  {
    img: "/assets/reefer.jpg",
    name: "Flatbed Trailer",
    length: "13.5 m",
    width: "2.4 m",
    height: "2.5 – 3.20 m",
  },
  {
    img: "/assets/truckAndTrailer.jpg",
    name: "Truck and Trailer",
    length: "13.5 m",
    width: "2.4 m",
    height: "2.5 – 3.20 m",
  },
  {
    img: "/assets/openTruck.jpg",
    name: "Open Truck",
    length: "6.25 – 7.5 m",
    width: "2.4 m",
    height: "2.5 – 3.20 m",
  },
  {
    img: "/assets/closedTruck.png",
    name: "Closed Truck",
    length: "6.25 – 7.5 m ",
    width: "2.4 m",
    height: "2.5 – 3.20 m",
  },
  {
    img: "/assets/closedContainer.png",
    name: "Closed Container",
    length: "15 – 19 m",
    width: "2.45 – 2.70 m",
    height: "2.80 – 3.10 m",
  },
  {
    img: "/assets/cattleLoader.png",
    name: "Cattle Loader",
    length: "17 – 19 m",
    width: "2.45 m",
    height: "2.5 – 3.20 m",
  },
  {
    img: "/assets/loader.png",
    name: "Loader",
    length: "13 – 17 m",
    width: "",
    height: "",
  },
  {
    img: "/assets/dumbTruck.png",
    name: "Loader",
    length: "6.25 m",
    width: "2.40 m",
    height: "1.5 – 2 m",
  },
  {
    img: "/assets/tankTruck.png",
    name: "Tank Truck",
    capacity: "40,000 – 46,000 liters",
    liquid: true,
  },
  {
    img: "/assets/carCarrier.png",
    name: "Car Carrier",
    number: "8 – 12",
    car: true,
  },
  {
    img: "/assets/dumbTruckTrailer.png",
    name: "Dump Truck with Tractor and Trailer",
    length: "15 – 16.5 m",
    width: "2.40 m",
    height: "1.5 – 2 m",
  },
];
const TruckType = () => {
  const { t } = useTranslation();
  return (
    <main>
      <article className="py-20">
        <div className="w-11/12 mx-auto">
          <span className="block mx-auto w-fit">
            <TruckIcon fill="#0051FF" className={"size-[60px]"} />
          </span>
          <h1 className="text-[24px] my-5 md:text-[32px] font-bold text-mainBlue text-center">
            {t("truckTypes")}
          </h1>
          <p className="mx-auto my-10 text-lg text-center text-mainGray">
            {t("containersAreUsed")}
          </p>
          <section className="grid grid-cols-1 gap-5 md:grid-cols-2">
            {trucks.map((truck, i) => (
              <Fragment key={i}>
                <TruckCard truck={truck} />
              </Fragment>
            ))}
          </section>
        </div>
      </article>
    </main>
  );
};

export default TruckType;
